import { Field, useFormikContext } from 'formik';
import MuiValidSelect from 'src/components/util/MuiValidSelect';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import { States } from 'src/data/states/constant';

/**
 * Address component for collecting property owner's address information
 *
 * @param {Object} props - The component props
 * @param {Object} props.fieldNames - An object containing the field names for the address form fields
 */
export default function Address({ fieldNames }) {
  const form = useFormikContext();

  const handleChange = (field) => (e) => {
    form.setFieldValue(field, e.target.value);
  };

  const fieldData = [
    {
      name: fieldNames.street,
      label: 'Street',
      type: 'text',
    },
    {
      name: fieldNames.city,
      label: 'City',
      type: 'text',
    },
    {
      name: fieldNames.state,
      label: 'State',
      type: 'select',
      itemLabels: States,
      itemValues: States,
    },
    {
      name: fieldNames.zip,
      label: 'ZIP',
      type: 'number',
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      {fieldData.map((field, index) => {
        if (field.type === 'select') {
          return (
            <Field
              className={'col-span-full sm:col-span-2 md:col-span-1'}
              component={MuiValidSelect}
              itemLabels={field.itemLabels}
              itemValues={field.itemValues}
              key={index}
              label={field.label}
              name={field.name}
              native
              onChange={handleChange(field.name)}
            />
          );
        } else {
          return (
            <Field
              InputLabelProps={{ shrink: true }}
              className={'col-span-full sm:col-span-6 md:col-span-3'}
              component={MuiValidTextField}
              label={field.label}
              key={index}
              name={field.name}
              onChange={handleChange(field.name)}
              type={field.type}
            />
          );
        }
      })}
    </div>
  );
}
